
import React from 'react';

const Logo = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <img
        src="/center.png" // Replace with your image URL
        alt="Description"
        className="max-w-full h-auto rounded-lg shadow-lg"
      />
    </div>
  );
};

export default Logo;
